import { useState, useEffect } from 'react';
import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import { useLang } from '../i18n';
import { useGeo } from '../geo';

const API = process.env.REACT_APP_API_BASE_URL;

const css = `
  .hi { padding: 6px 16px 28px; }

  /* Tab bar */
  .hi-tabs { display: flex; gap: 5px; background: #16142e; border-radius: 11px; padding: 4px; margin-bottom: 12px; }
  .hi-tab { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; height: 36px; border-radius: 8px; font-size: 12px; font-weight: 700; color: #6a6982; transition: all .15s; white-space: nowrap; }
  .hi-tab.on { background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; }
  .hi-tab-badge { font-size: 10px; font-weight: 800; padding: 1px 6px; border-radius: 10px; background: rgba(255,255,255,.15); color: inherit; line-height: 16px; }
  .hi-tab.on .hi-tab-badge { background: rgba(255,255,255,.25); }


  /* Card */
  .hi-card { margin-top: 10px; border-radius: 2px; background: #16142e; overflow: hidden; position: relative; }
  .hi-card::before { content: ''; position: absolute; left: 0; top: 0; height: 48px; width: 2px; }
  .hi-card.won::before  { background: linear-gradient(180deg, #00d26a, #00a84f); }
  .hi-card.lost::before { background: linear-gradient(180deg, #ff5d6c, #cc2233); }
  .hi-card.pending::before { background: linear-gradient(180deg, #f6c344, #e0a000); }

  /* Top section */
  .hi-top { padding: 13px 13px 11px 16px; box-shadow: inset 0 -1px 0 rgba(255,255,255,.05); }
  .hi-top-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }
  .hi-match { font-size: 14px; font-weight: 800; color: #fff; line-height: 1.25; }
  .hi-pick { display: inline-flex; align-items: center; gap: 5px; margin-top: 6px; padding: 3px 9px; border-radius: 20px; background: rgba(118,225,255,.08); box-shadow: inset 0 0 0 1px rgba(118,225,255,.14); }
  .hi-pick-label { font-size: 11px; font-weight: 700; color: #76e1ff; }
  .hi-date { font-size: 10px; color: #5a5972; margin-top: 5px; }
  .hi-badge { font-size: 10px; font-weight: 800; padding: 4px 10px; border-radius: 20px; flex: none; white-space: nowrap; letter-spacing: .3px; }
  .hi-badge.won     { color: #00d26a; background: rgba(0,210,106,.13); box-shadow: inset 0 0 0 1px rgba(0,210,106,.25); }
  .hi-badge.lost    { color: #ff5d6c; background: rgba(255,93,108,.13); box-shadow: inset 0 0 0 1px rgba(255,93,108,.25); }
  .hi-badge.pending { color: #f6c344; background: rgba(246,195,68,.13); box-shadow: inset 0 0 0 1px rgba(246,195,68,.25); }

  /* Stats */
  .hi-stats { display: flex; padding: 11px 13px 11px 16px; }
  .hi-stat { flex: 1; display: flex; flex-direction: column; gap: 3px; }
  .hi-stat + .hi-stat { border-left: 1px solid rgba(255,255,255,.06); padding-left: 12px; }
  .hi-k { font-size: 9px; font-weight: 700; color: #5a5972; letter-spacing: .6px; text-transform: uppercase; }
  .hi-v { font-size: 14px; font-weight: 800; color: #fff; }
  .hi-v.odds { color: #76e1ff; }
  .hi-v.win { color: #00d26a; }

  /* Footer */
  .hi-foot { display: flex; align-items: center; justify-content: flex-end; padding: 0 13px 10px 16px; }
  .hi-share-btn { display: inline-flex; align-items: center; gap: 5px; height: 26px; padding: 0 10px; border-radius: 6px; background: rgba(255,255,255,.05); color: #757490; font-size: 10px; font-weight: 700; border: none; cursor: pointer; transition: background .15s, color .15s; letter-spacing: .2px; }
  .hi-share-btn:hover { background: rgba(255,255,255,.09); color: #fff; }

  .hi-empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 52px 20px; color: #5a5972; font-size: 13px; }

  /* Share modal */
  .sh-overlay { position: fixed; inset: 0; z-index: 300; background: rgba(2,1,15,.8); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; padding: 24px; animation: sh-bg-in .2s ease; }
  @keyframes sh-bg-in { from { opacity:0; } to { opacity:1; } }
  .sh-panel { width: 100%; max-width: 340px; background: #111027; border-radius: 22px; box-shadow: 0 40px 100px rgba(0,0,0,.8), inset 0 0 0 1px rgba(255,255,255,.07); overflow: hidden; animation: sh-pop-in .3s cubic-bezier(.34,1.4,.64,1); }
  @keyframes sh-pop-in { from { opacity:0; transform: scale(.86) translateY(12px); } to { opacity:1; transform: scale(1) translateY(0); } }

  .sh-header { display: flex; align-items: center; justify-content: space-between; padding: 18px 18px 0; }
  .sh-title { font-size: 14px; font-weight: 700; color: #9b9ab0; letter-spacing: .3px; }
  .sh-close { width: 28px; height: 28px; border-radius: 50%; background: rgba(255,255,255,.07); display: grid; place-items: center; border: none; cursor: pointer; }

  /* Ticket */
  .sh-ticket { margin: 16px 16px 0; border-radius: 16px; background: #0a0919; box-shadow: inset 0 0 0 1px rgba(255,255,255,.07); overflow: hidden; }
  .sh-ticket-hero { display: flex; flex-direction: column; align-items: center; padding: 18px 20px 22px; position: relative; overflow: hidden; }
  .sh-ticket-brand { position: relative; display: flex; align-items: center; justify-content: flex-start; width: 100%; margin-bottom: 16px; }
  .sh-ticket-logo { height: 18px; width: auto; object-fit: contain; opacity: .95; }
  .sh-ticket-glow { position: absolute; inset: 0; pointer-events: none; }
  .sh-ticket-glow.won     { background: radial-gradient(ellipse at 50% 0%, rgba(0,210,106,.18) 0%, transparent 65%); }
  .sh-ticket-glow.lost    { background: radial-gradient(ellipse at 50% 0%, rgba(255,93,108,.18) 0%, transparent 65%); }
  .sh-ticket-glow.pending { background: radial-gradient(ellipse at 50% 0%, rgba(246,195,68,.15) 0%, transparent 65%); }
  .sh-ticket-result { display: inline-flex; align-items: center; gap: 7px; margin-bottom: 14px; padding: 5px 12px 5px 6px; border-radius: 20px; }
  .sh-ticket-result.won     { background: rgba(0,210,106,.1); }
  .sh-ticket-result.lost    { background: rgba(255,93,108,.1); }
  .sh-ticket-result.pending { background: rgba(246,195,68,.1); }
  .sh-ticket-icon { width: 24px; height: 24px; border-radius: 50%; display: grid; place-items: center; flex: none; }
  .sh-ticket-icon svg { width: 14px; height: 14px; }
  .sh-ticket-icon.won     { background: rgba(0,210,106,.2); }
  .sh-ticket-icon.lost    { background: rgba(255,93,108,.2); }
  .sh-ticket-icon.pending { background: rgba(246,195,68,.18); }
  .sh-ticket-status { font-size: 10px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; }
  .sh-ticket-status.won     { color: #00d26a; }
  .sh-ticket-status.lost    { color: #ff5d6c; }
  .sh-ticket-status.pending { color: #f6c344; }
  .sh-ticket-match { font-size: 13px; font-weight: 700; color: #fff; text-align: center; line-height: 1.35; margin-bottom: 4px; max-width: 100%; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .sh-ticket-sel { font-size: 11px; color: #757490; text-align: center; margin-bottom: 18px; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .sh-ticket-amount-k { font-size: 9px; font-weight: 700; letter-spacing: .8px; text-transform: uppercase; color: #3e3c5a; margin-bottom: 6px; }
  .sh-ticket-amount { font-size: 26px; font-weight: 600; line-height: 1; letter-spacing: -.5px; }
  .sh-ticket-amount.won     { color: #00d26a; }
  .sh-ticket-amount.lost    { color: #ff5d6c; }
  .sh-ticket-amount.pending { color: #76e1ff; }
  .sh-ticket-sep { width: 100%; display: flex; align-items: center; gap: 0; position: relative; margin: 22px 0 0; }
  .sh-ticket-sep::before { content:''; position:absolute; width:100%; left:auto; height:1px; background: repeating-linear-gradient(90deg, rgba(255,255,255,.1) 0px, rgba(255,255,255,.1) 6px, transparent 6px, transparent 12px); }
  .sh-ticket-notch { width: 18px; height: 18px; border-radius: 50%; background: #111027; box-shadow: inset 0 0 0 1px rgba(255,255,255,.07); flex: none; }
  .sh-ticket-notch.l { margin-left: -26px; }
  .sh-ticket-notch.r { margin-right: -26px; margin-left: auto; }
  .sh-ticket-stats { display: flex; padding: 0 20px 20px; gap: 0; margin-top: -16px; }
  .sh-pstat { flex: 1; display: flex; flex-direction: column; gap: 4px; align-items: center; }
  .sh-pstat + .sh-pstat { border-left: 1px solid rgba(255,255,255,.06); }
  .sh-pstat-k { font-size: 9px; font-weight: 700; letter-spacing: .7px; text-transform: uppercase; color: #3e3c5a; }
  .sh-pstat-v { font-size: 14px; font-weight: 800; color: #cfcee0; }
  .sh-ticket-foot { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 20px 16px; border-top: 1px solid rgba(255,255,255,.06); }
  .sh-ticket-user { display: inline-flex; align-items: center; gap: 5px; font-size: 11px; font-weight: 700; color: #9b9ab0; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .sh-ticket-user svg { flex: none; color: #76e1ff; }
  .sh-ticket-date { font-size: 10px; font-weight: 600; color: #5a5972; flex: none; }

  /* Actions */
  .sh-actions { display: flex; gap: 8px; padding: 14px 16px 18px; }
  .sh-btn { flex: 1; height: 46px; border-radius: 13px; font-size: 13px; font-weight: 700; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 7px; font-family: inherit; transition: opacity .15s; }
  .sh-btn:active { opacity: .75; }
  .sh-btn.dl { background: rgba(255,255,255,.06); color: #9b9ab0; box-shadow: inset 0 0 0 1px rgba(255,255,255,.09); }
  .sh-btn.share { background: linear-gradient(90deg,#8187f6,#76e1ff); color: #fff; box-shadow: 0 6px 20px rgba(118,225,255,.2); }

  .sh-toast { position: fixed; bottom: 36px; left: 50%; transform: translateX(-50%); background: #00d26a; color: #021a0d; font-size: 13px; font-weight: 700; padding: 10px 22px; border-radius: 20px; z-index: 400; animation: sh-toast-in .25s ease; white-space: nowrap; pointer-events: none; }
  @keyframes sh-toast-in { from { opacity:0; transform: translateX(-50%) translateY(10px); } to { opacity:1; transform: translateX(-50%) translateY(0); } }
`;

const TABS = ['all', 'pending', 'won', 'lost'];

const THEME_COLORS = {
  1: { bg1: '#1a1535', bg2: '#0d0b22', accent: '#8187f6', glow: 'rgba(129,135,246,.22)' },
  2: { bg1: '#0a2010', bg2: '#051209', accent: '#00d26a', glow: 'rgba(0,210,106,.18)' },
  3: { bg1: '#220d15', bg2: '#100509', accent: '#ff5d6c', glow: 'rgba(255,93,108,.18)' },
};

function formatDate(str) {
  if (!str) return '';
  const d = new Date(str);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' }) + ' · ' +
    d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

function formatDateShort(str) {
  if (!str) return '';
  return new Date(str).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function drawBallWatermark(ctx, x, y, r, sport) {
  ctx.save();
  ctx.globalAlpha = 0.13;
  ctx.strokeStyle = '#fff';
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = r * 0.055;

  if (sport === 'basketball') {
    ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(x - r, y); ctx.lineTo(x + r, y); ctx.stroke();
    ctx.beginPath(); ctx.arc(x - r * 0.52, y, r * 0.82, -Math.PI * 0.62, Math.PI * 0.62); ctx.stroke();
    ctx.beginPath(); ctx.arc(x + r * 0.52, y, r * 0.82, Math.PI * (1 - 0.62), Math.PI * (1 + 0.62)); ctx.stroke();
  } else if (sport === 'tennis') {
    ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.arc(x, y - r * 0.48, r * 0.72, Math.PI * 0.18, Math.PI * 0.82); ctx.stroke();
    ctx.beginPath(); ctx.arc(x, y + r * 0.48, r * 0.72, Math.PI * 1.18, Math.PI * 1.82); ctx.stroke();
  } else {
    // football
    const pOff = -Math.PI / 2;
    ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.stroke();
    const pr = r * 0.21;
    ctx.beginPath();
    for (let i = 0; i <= 5; i++) {
      const a = (i / 5) * Math.PI * 2 + pOff;
      i === 0 ? ctx.moveTo(x + Math.cos(a) * pr, y + Math.sin(a) * pr)
              : ctx.lineTo(x + Math.cos(a) * pr, y + Math.sin(a) * pr);
    }
    ctx.stroke();
    const hr = r * 0.175;
    for (let i = 0; i < 5; i++) {
      const mid = ((i + 0.5) / 5) * Math.PI * 2 + pOff;
      const hx = x + Math.cos(mid) * r * 0.58;
      const hy = y + Math.sin(mid) * r * 0.58;
      ctx.beginPath();
      for (let j = 0; j <= 6; j++) {
        const a = (j / 6) * Math.PI * 2 + mid;
        j === 0 ? ctx.moveTo(hx + Math.cos(a) * hr, hy + Math.sin(a) * hr)
                : ctx.lineTo(hx + Math.cos(a) * hr, hy + Math.sin(a) * hr);
      }
      ctx.stroke();
      const va = (i / 5) * Math.PI * 2 + pOff;
      ctx.beginPath();
      ctx.moveTo(x + Math.cos(va) * pr, y + Math.sin(va) * pr);
      ctx.lineTo(hx - Math.cos(mid) * hr, hy - Math.sin(mid) * hr);
      ctx.stroke();
    }
  }
  ctx.restore();
}

function generateShareImage(bet, theme, sport, t, symbol, rate, username) {
  const W = 540, H = 880;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');
  const th = THEME_COLORS[theme] || THEME_COLORS[1];
  const status = bet.status || 'pending';
  const sel = (bet.details || [])[0] || {};
  const odds = parseFloat(sel.cote || bet.cote_totale || 0);
  const stake = parseFloat(bet.mise_totale || 0) * rate;
  const payout = parseFloat(status === 'won' ? (bet.gain_reel || bet.gain_potentiel) : bet.gain_potentiel || 0) * rate;
  const matchName = sel.match_name || 'Match';
  const selection = sel.selection_name || '';

  // Background
  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, th.bg1);
  bg.addColorStop(1, th.bg2);
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  // Glow
  const glow = ctx.createRadialGradient(W / 2, 260, 0, W / 2, 260, 280);
  glow.addColorStop(0, th.glow);
  glow.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  // Sport ball watermark
  drawBallWatermark(ctx, W / 2, 310, 150, sport);

  // Border rect
  ctx.strokeStyle = th.accent + '55';
  ctx.lineWidth = 2;
  ctx.strokeRect(16, 16, W - 32, H - 32);

  // Logo
  ctx.font = '700 22px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = 'rgba(255,255,255,.35)';
  ctx.letterSpacing = '4px';
  ctx.textAlign = 'center';
  ctx.fillText('ROXS SPORTS', W / 2, 80);

  // Status
  const statusLabel = status === 'won' ? t('mybets.badgeWon') : status === 'lost' ? t('mybets.badgeLost') : t('mybets.badgePending');
  const statusColor = status === 'won' ? '#00d26a' : status === 'lost' ? '#ff5d6c' : '#f6c344';
  ctx.font = '800 19px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = statusColor;
  ctx.fillText(statusLabel.toUpperCase(), W / 2, 152);

  // Divider
  ctx.strokeStyle = 'rgba(255,255,255,.08)';
  ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(60, 172); ctx.lineTo(W - 60, 172); ctx.stroke();

  // Match name
  ctx.font = '700 26px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = '#fff';
  ctx.fillText(matchName.length > 32 ? matchName.slice(0, 32) + '…' : matchName, W / 2, 218);

  // Selection
  if (selection) {
    ctx.font = '400 16px "Helvetica Neue", Arial, sans-serif';
    ctx.fillStyle = 'rgba(255,255,255,.45)';
    ctx.fillText(selection.length > 40 ? selection.slice(0, 40) + '…' : selection, W / 2, 252);
  }

  // Big amount
  const amountPrefix = status === 'won' ? '+' : status === 'lost' ? '-' : '';
  const amountColor = status === 'won' ? '#00d26a' : status === 'lost' ? '#ff5d6c' : '#76e1ff';
  ctx.font = '800 62px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = amountColor;
  ctx.fillText(`${amountPrefix}${payout.toFixed(2)} ${symbol}`, W / 2, 366);

  // Stats row
  const statY = 440;
  const cols = [
    { k: t('mybets.odds'), v: odds > 0 ? `×${odds.toFixed(2)}` : '—' },
    { k: t('mybets.stake'), v: `${stake.toFixed(2)} ${symbol}` },
  ];
  const colW = W / cols.length;
  cols.forEach((col, i) => {
    const cx = colW * i + colW / 2;
    ctx.font = '700 11px "Helvetica Neue", Arial, sans-serif';
    ctx.fillStyle = 'rgba(255,255,255,.3)';
    ctx.fillText(col.k.toUpperCase(), cx, statY);
    ctx.font = '700 18px "Helvetica Neue", Arial, sans-serif';
    ctx.fillStyle = '#fff';
    ctx.fillText(col.v, cx, statY + 26);
  });

  // User + date
  const betDate = formatDateShort(bet.created_at || bet.date_pari);
  ctx.letterSpacing = '0px';
  ctx.font = '700 16px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = 'rgba(255,255,255,.55)';
  if (username) ctx.fillText(username, W / 2, H - 96);
  if (betDate) {
    ctx.font = '400 13px "Helvetica Neue", Arial, sans-serif';
    ctx.fillStyle = 'rgba(255,255,255,.32)';
    ctx.fillText(betDate, W / 2, H - 72);
  }

  // Bottom watermark
  ctx.font = '400 13px "Helvetica Neue", Arial, sans-serif';
  ctx.fillStyle = 'rgba(255,255,255,.15)';
  ctx.fillText('roxs-sports.com', W / 2, H - 36);

  return canvas;
}

const SPORTS = [
  { id: 'football',   emoji: '⚽', label: 'Foot' },
  { id: 'basketball', emoji: '🏀', label: 'Basket' },
  { id: 'tennis',     emoji: '🎾', label: 'Tennis' },
];

function ShareModal({ bet, onClose, t }) {
  const [toast, setToast] = useState('');
  const { symbol, rate } = useGeo().prices;

  const user = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();
  const username = user?.username || [user?.prenom, user?.nom].filter(Boolean).join(' ') || 'Roxs Sports';
  const betDate = formatDateShort(bet.created_at || bet.date_pari);

  const status = bet.status || 'pending';
  const sel = (bet.details || [])[0] || {};
  const odds = parseFloat(sel.cote || bet.cote_totale || 0);
  const stake = parseFloat(bet.mise_totale || 0) * rate;
  const payout = parseFloat(status === 'won' ? (bet.gain_reel || bet.gain_potentiel) : bet.gain_potentiel || 0) * rate;
  const matchName = sel.match_name || 'Match';
  const selection = sel.selection_name || '';
  const amountPrefix = status === 'won' ? '+' : status === 'lost' ? '-' : '';
  const amountColor = status === 'won' ? '#00d26a' : status === 'lost' ? '#ff5d6c' : '#76e1ff';
  const resultLabel = status === 'won' ? t('mybets.badgeWon') : status === 'lost' ? t('mybets.badgeLost') : t('mybets.badgePending');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2200); };

  const handleDownload = () => {
    const canvas = generateShareImage(bet, 1, 'football', t, symbol, rate, username);
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `roxs-sports-${status}-${Date.now()}.png`;
      a.click();
      URL.revokeObjectURL(url);
      showToast(t('mybets.share.downloaded'));
    }, 'image/png');
  };

  const handleShare = async () => {
    const text = `${resultLabel.toUpperCase()} — ${matchName}\n${selection ? selection + '\n' : ''}${t('mybets.odds')}: ×${odds.toFixed(2)}  •  ${t('mybets.stake')}: ${stake.toFixed(2)} ${symbol}  •  ${amountPrefix}${payout.toFixed(2)} ${symbol}\n🎯 roxs-sports.com`;
    if (navigator.share) {
      try {
        const canvas = generateShareImage(bet, 1, 'football', t, symbol, rate, username);
        canvas.toBlob(async (blob) => {
          const file = new File([blob], 'roxs-sports.png', { type: 'image/png' });
          try {
            await navigator.share({ files: [file], title: 'Roxs Sports', text });
          } catch {
            await navigator.share({ title: 'Roxs Sports', text });
          }
        }, 'image/png');
      } catch { showToast(t('mybets.share.copied')); }
    } else {
      navigator.clipboard.writeText(text).then(() => showToast(t('mybets.share.copied'))).catch(() => {});
    }
  };

  const StatusIcon = () => {
    if (status === 'won') return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M5 13l6 6L21 7" stroke="#00d26a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
    if (status === 'lost') return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M4 4l14 14M18 4L4 18" stroke="#ff5d6c" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    );
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="9" stroke="#f6c344" strokeWidth="2"/>
        <path d="M11 7v5l3 3" stroke="#f6c344" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    );
  };

  return (
    <div className="sh-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="sh-panel">

        <div className="sh-header">
          <span className="sh-title">{t('mybets.share.title')}</span>
          <button className="sh-close" onClick={onClose}>
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M1 1l9 9M10 1L1 10" stroke="#9b9ab0" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="sh-ticket">
          <div className="sh-ticket-hero">
            <div className={'sh-ticket-glow ' + status} />
            <div className="sh-ticket-brand">
              <img className="sh-ticket-logo" src="/logo.png" alt="Roxs Sports" />
            </div>
            <div className={'sh-ticket-result ' + status}>
              <span className={'sh-ticket-icon ' + status}><StatusIcon /></span>
              <span className={'sh-ticket-status ' + status}>{resultLabel}</span>
            </div>
            <div className="sh-ticket-match">{matchName}</div>
            {selection && <div className="sh-ticket-sel">{selection}</div>}
            <div className="sh-ticket-amount-k">{status === 'won' ? t('mybets.win') : t('mybets.potentialWin')}</div>
            <div className={'sh-ticket-amount ' + status}>{amountPrefix}{payout.toFixed(2)} {symbol}</div>
            <div className="sh-ticket-sep">
              <div className="sh-ticket-notch l" />
              <div className="sh-ticket-notch r" />
            </div>
          </div>
          <div className="sh-ticket-stats">
            <div className="sh-pstat">
              <span className="sh-pstat-k">{t('mybets.odds')}</span>
              <span className="sh-pstat-v">{odds > 0 ? `×${odds.toFixed(2)}` : '—'}</span>
            </div>
            <div className="sh-pstat">
              <span className="sh-pstat-k">{t('mybets.stake')}</span>
              <span className="sh-pstat-v">{stake.toFixed(2)} {symbol}</span>
            </div>
          </div>
          <div className="sh-ticket-foot">
            <span className="sh-ticket-user">
              <svg width="11" height="11" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.6"/><path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
              {username}
            </span>
            {betDate && <span className="sh-ticket-date">{betDate}</span>}
          </div>
        </div>

        <div className="sh-actions">
          <button className="sh-btn dl" onClick={handleDownload}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M12 3v13M7 11l5 5 5-5M3 19h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('mybets.share.download')}
          </button>
          <button className="sh-btn share" onClick={handleShare}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="18" cy="5" r="3" stroke="#fff" strokeWidth="1.8"/>
              <circle cx="6" cy="12" r="3" stroke="#fff" strokeWidth="1.8"/>
              <circle cx="18" cy="19" r="3" stroke="#fff" strokeWidth="1.8"/>
              <path d="M8.59 13.51l6.83 3.98M15.41 6.51L8.59 10.49" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
            {t('mybets.share.share')}
          </button>
        </div>

      </div>
      {toast && <div className="sh-toast">{toast}</div>}
    </div>
  );
}

function Spinner() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" style={{ animation: 'spin 0.8s linear infinite' }}>
        <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
        <circle cx="14" cy="14" r="11" stroke="rgba(255,255,255,.12)" strokeWidth="2.5" />
        <path d="M14 3a11 11 0 0110.18 6.85" stroke="#76e1ff" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </div>
  );
}

export default function MyBets() {
  const { t } = useLang();
  const { symbol, rate } = useGeo().prices;
  const [user]   = useState(() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } });
  const [tab, setTab]   = useState('all');
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [shareBet, setShareBet] = useState(null);

  useEffect(() => {
    if (!user?.id) { setLoading(false); return; }
    setLoading(true);

    const loadBets = () => {
      fetch(`${API}/api-bet/bets/user-bets.php?user_id=${user.id}`)
        .then((r) => r.json())
        .then((data) => {
          if (data.success) {
            const mapStatus = (s) => s === 'Gagné' ? 'won' : s === 'Perdu' ? 'lost' : 'pending';
            setBets((data.bets || []).map(b => ({ ...b, status: mapStatus(b.statut) })));
          } else {
            setError(data.message || t('mybets.loadError'));
          }
        })
        .catch(() => setError(t('mybets.loadError')))
        .finally(() => setLoading(false));
    };

    const checkUrl = `${API}/api-bet/bets/check-results-test.php?user_id=${user.id}`;
    fetch(checkUrl)
      .then((r) => r.json())
      .then((data) => {
if (data.success && data.results && (data.results.won > 0 || data.results.refunded > 0)) {
          fetch(`${API}/api/user/infos.php?id=${user.id}`)
            .then((r) => r.json())
            .then((ud) => {
              if (ud.success) {
                const updated = { ...user, ...ud.data };
                localStorage.setItem('user', JSON.stringify(updated));
                window.dispatchEvent(new Event('userUpdated'));
              }
            })
            .catch(() => {});
        }
      })
      .catch(() => {})
      .finally(() => loadBets());
  }, [user?.id]);

  const list = bets.filter((b) => tab === 'all' || b.status === tab);
  const firstSel = (bet) => (bet.details || [])[0] || {};

  return (
    <PhoneShell activeTab="">
      <style>{css}</style>
      <BackHeader title={t('mybets.title')} />
      <div className="hi">
        {(() => {
          const counts = {
            all:     bets.length,
            won:     bets.filter(b => b.status === 'won').length,
            lost:    bets.filter(b => b.status === 'lost').length,
            pending: bets.filter(b => b.status === 'pending').length,
          };
          return (
            <>
              <div className="hi-tabs">
                {TABS.map((id) => (
                  <button key={id} className={'hi-tab' + (tab === id ? ' on' : '')} onClick={() => setTab(id)}>
                    {t('mybets.' + id)}
                    <span className="hi-tab-badge">{counts[id]}</span>
                  </button>
                ))}
              </div>
            </>
          );
        })()}

        {loading ? <Spinner /> : error ? (
          <div className="hi-empty">{error}</div>
        ) : list.length === 0 ? (
          <div className="hi-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path d="M5 4.5h11a1 1 0 011 1V20l-2-1.3L13 20l-2-1.3L9 20l-2-1.3L5 20V4.5z" stroke="#3a3857" strokeWidth="1.3" strokeLinejoin="round" />
              <path d="M8 8.5h7M8 11.5h7M8 14.5h4" stroke="#3a3857" strokeWidth="1.3" strokeLinecap="round" />
            </svg>
            {t('mybets.noBets')}
          </div>
        ) : (
          <>
            {list.map((b, i) => {
              const sel = firstSel(b);
              const odds = parseFloat(sel.cote || b.cote_totale || 0);
              const stake = parseFloat(b.mise_totale || 0) * rate;
              const payout = parseFloat(b.status === 'won' ? (b.gain_reel || b.gain_potentiel) : b.gain_potentiel || 0) * rate;
              const date = formatDate(b.created_at || b.date_pari);
              const status = b.status || 'pending';
              const badgeLabel = t('mybets.badge' + status.charAt(0).toUpperCase() + status.slice(1));

              return (
                <div className={'hi-card ' + status} key={b.id || i}>
                  <div className="hi-top">
                    <div className="hi-top-row">
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div className="hi-match">{sel.match_name || 'Match'}</div>
                      </div>
                      <span className={'hi-badge ' + status}>{badgeLabel}</span>
                    </div>
                    {sel.selection_name && (
                      <div className="hi-pick">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="#76e1ff"><circle cx="4" cy="4" r="3"/></svg>
                        <span className="hi-pick-label">{sel.selection_name}</span>
                      </div>
                    )}
                    {date && <div className="hi-date">{date}</div>}
                  </div>

                  <div className="hi-stats">
                    <div className="hi-stat">
                      <span className="hi-k">{t('mybets.odds')}</span>
                      <span className="hi-v odds">{odds > 0 ? `×${odds.toFixed(2)}` : '—'}</span>
                    </div>
                    <div className="hi-stat">
                      <span className="hi-k">{t('mybets.stake')}</span>
                      <span className="hi-v">{stake.toFixed(2)} {symbol}</span>
                    </div>
                    <div className="hi-stat">
                      <span className="hi-k">{status === 'won' ? t('mybets.win') : t('mybets.potentialWin')}</span>
                      <span className={'hi-v' + (status === 'won' ? ' win' : '')}>{payout.toFixed(2)} {symbol}</span>
                    </div>
                  </div>

                  <div className="hi-foot">
                    <button className="hi-share-btn" onClick={() => setShareBet(b)}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                        <circle cx="18" cy="5" r="3" stroke="currentColor" strokeWidth="1.8"/>
                        <circle cx="6" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
                        <circle cx="18" cy="19" r="3" stroke="currentColor" strokeWidth="1.8"/>
                        <path d="M8.59 13.51l6.83 3.98M15.41 6.51L8.59 10.49" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                      </svg>
                      {t('mybets.share.share')}
                    </button>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>

      {shareBet && <ShareModal bet={shareBet} onClose={() => setShareBet(null)} t={t} />}
    </PhoneShell>
  );
}
